import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Seo } from '@/components/common/Seo';
import { OphirButton } from '@/components/common/OphirButton';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { adminLogin } from '@/lib/api';

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem('ophir_admin_token', res.token);
      localStorage.setItem('ophir_admin_email', res.email);
      toast.success('Signed in');
      nav('/admin/dashboard');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Invalid email or password');
    } finally { setLoading(false); }
  };

  return (
    <>
      <Seo title="Admin | OPHIR SUPPLY" description="OPHIR SUPPLY admin access." />
      <div className="min-h-screen flex items-center justify-center bg-ophir-ivory-soft px-4">
        <div className="w-full max-w-md bg-white border border-ophir-grey rounded-2xl shadow-ophir p-8">
          <img src="/images/ophir/logo/ophir-logo-full.png" alt="OPHIR SUPPLY" className="h-11 w-auto mx-auto" style={{ maxWidth: 220 }} />
          <h1 className="mt-6 font-serif text-[24px] text-ophir-navy-deep text-center">Administrator sign in</h1>
          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
            <div>
              <Label className="text-[12px] font-semibold uppercase tracking-[0.1em] text-ophir-navy">Email</Label>
              <Input type="email" data-testid="admin-login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2" required />
            </div>
            <div>
              <Label className="text-[12px] font-semibold uppercase tracking-[0.1em] text-ophir-navy">Password</Label>
              <Input type="password" data-testid="admin-login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2" required />
            </div>
            <OphirButton type="submit" data-testid="admin-login-submit" className="w-full" disabled={loading}>
              {loading ? 'Signing in\u2026' : 'Sign in'}
            </OphirButton>
          </form>
        </div>
      </div>
    </>
  );
}
